import {
  DOCTOR_REPORT,
  REPORT_COUNT,
  EXCEL_REPORT_LIST,
  SEARCH_DISEASE_DATA,
  SEARCH_DIAGONSIS_DATA,
  SEARCH_SPECIALIZATION_DATA,
  SEARCH_SYMPTOMS_DATA,
  TAG_CATEGORY_REPORT,
  SEARCH_MEDICINE_DATA,
  ALLERGY_REPORT,
  PROCEDURE_REPORT,
  REPORT_RESULT,
  REPORT_RESULT_SUCCESS,
  CLIENT_LIST_REPORT,
  REPORT_TAB_COUNT,
} from '../../shared/constants/ActionTypes';

const initialState = {
  clientlist: '',
  doctorlist: '',
  reportcount: '',
  reportoldcount: '',
  allergyreport: '',
  procedurereport: '',
  search_disease_data: [],
  excel_report: [],
  reportresult: [],
  reportresultsuccess: '',
  tagcategory: [],
  eRxtabcount: 0,
};
const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOCTOR_REPORT:
      return {
        ...state,
        doctorlist: action.payload,
      };
    case REPORT_COUNT:
      return {
        ...state,
        reportcount: action.payload,
      };
    case EXCEL_REPORT_LIST:
      return {
        ...state,
        excel_report: action.payload,
      };
    case CLIENT_LIST_REPORT:
      return {
        ...state,
        clientlist: action.payload,
      };
    case REPORT_RESULT:
      return {
        ...state,
        reportresult: action.payload,
      };
    case REPORT_RESULT_SUCCESS:
      return {
        ...state,
        reportresultsuccess: action.payload,
      };
    case SEARCH_DIAGONSIS_DATA:
      return {
        ...state,
        search_diagonsis_data: action.payload,
      };
    case SEARCH_DISEASE_DATA:
      return {
        ...state,
        search_disease_data: action.payload,
      };
    case SEARCH_SYMPTOMS_DATA:
      return {
        ...state,
        search_symptoms_data: action.payload,
      };
    case SEARCH_SPECIALIZATION_DATA:
      return {
        ...state,
        search_specialization_data: action.payload,
      };
    case ALLERGY_REPORT:
      return {
        ...state,
        allergyreport: action.payload,
      };
    case PROCEDURE_REPORT:
      return {
        ...state,
        procedurereport: action.payload,
      };
    case SEARCH_MEDICINE_DATA:
      return {
        ...state,
        search_medicine_data: action.payload,
      };
    case TAG_CATEGORY_REPORT:
      return {
        ...state,
        tagcategory: action.payload,
      };
    case REPORT_TAB_COUNT:
      return {
        ...state,
        eRxtabcount: action.payload,
      };
    default:
      return state;
  }
};

export default reportReducer;
